<div class="flex-fill d-flex flex-column card p-3">
  <div class="card">
    <div class="card-body" style="max-width: 300px">
      <dx-form [formData]="filter" appAutofocusForm="partNumber" (onEditorEnterKey)="getData()">
        <dxi-item dataField="startDate" editorType="dxDateBox"></dxi-item>
        <dxi-item dataField="endDate" editorType="dxDateBox"></dxi-item>
      </dx-form>
      <div class="btn-toolbar justify-content-end align-items-center mt-1">
        <button accesskey="s" (click)="getData()" class="btn btn-primary">Search</button>
        <button (click)="clear()" class="btn btn-secondary ms-2">Clear</button>
      </div>
    </div>
  </div>
  <div class="d-flex flex-fill flex-column">
    <!-- Invoice Line Summaries -->

    <table style="max-width: 600px" class="m-3">
      <thead>
        <tr>
          <th>SubTotal</th>
          <th>Tax Total</th>
          <th>Gross Sales w/ Tax</th>
          <th>Invoice Count</th>
        </tr>
      </thead>
      @if (invoiceSummaries) {
        <tbody>
          <td>{{ invoiceSummaries.subTotal| currency }}</td>
          <td>{{ invoiceSummaries.tax| currency }}</td>
          <td>{{ invoiceSummaries.total| currency }}</td>
          <td>{{ invoiceSummaries.count| number }}</td>
        </tbody>
      }
    </table>

    <table style="max-width: 600px" class="m-3">
      <thead>
        <tr>
          <th>Gross Sales w/o Tax</th>
          <th>NonTaxable</th>
          <th>Taxable</th>
          <!-- <th>Tax Amount</th> -->
        </tr>
      </thead>
      @if (invoiceLineSummaries) {
        <tbody>
          <td>{{ invoiceLineSummaries.taxable + invoiceLineSummaries.nonTaxable | currency }}</td>
          <td>{{ invoiceLineSummaries.nonTaxable | currency }}</td>
          <td>{{ invoiceLineSummaries.taxable | currency }}</td>
          <!-- <td>{{ 0.06 * invoiceLineSummaries.taxable | currency }}</td> -->
        </tbody>
      }
    </table>

    <table style="max-width: 600px" class="m-3">
      <thead>
        <tr>
          <th>Type of Sales</th>
          <th>Total</th>
          <th>Taxable Total</th>
          <th>NonTaxable Total</th>
        </tr>
      </thead>
      @if (summaries && totals) {
        <tbody>
          @for (summary of summaries.taxable; track summary) {
            <tr>
              <td>{{ summary.name }}</td>
              <td>{{ summary.total | currency }}</td>
              <td>{{ summary.taxableTotal | currency }}</td>
              <td>{{ summary.nonTaxableTotal | currency }}</td>
            </tr>
          }
          <tr>
            <td></td>
            <td>---------------</td>
            <td>---------------</td>
          </tr>
          <!-- <tr class="totals">
          <td>Taxable Sales</td>
          <td>{{ totals.taxable.total | currency }}</td>
        </tr> -->
        @for (summary of summaries?.nonTaxable; track summary) {
          <tr>
            <td>{{ summary.name }}</td>
            <td>{{ summary.total | currency }}</td>
            <td>{{ summary.taxableTotal | currency }}</td>
            <td>{{ summary.nonTaxableTotal | currency }}</td>
          </tr>
        }
        <tr>
          <td></td>
          <td>---------------</td>
          <td>---------------</td>
        </tr>
        <tr class="totals">
          <td>Non-Taxable Sales</td>
          <td>{{ totals.nonTaxable.total | currency }}</td>
        </tr>
        <tr class="totals">
          <td>Total Sales</td>
          <td>{{ totals.taxable.total + totals.nonTaxable.total | currency }}</td>
        </tr>
      </tbody>
    }
  </table>
</div>
</div>
